import { OpenAPI } from "../../../services/core/OpenAPI";
var IGNORED_DOMAINS = [
    'kenya-airways-frontend.heathmans.net',
];
export var getIsOpti = function () {
    var domain = window.location.hostname;
    var lang = document.documentElement.lang;
    var isStorybookLocal = domain === 'localhost' && window.location.port === '6006';
    if (!lang || isStorybookLocal || IGNORED_DOMAINS.includes(domain)) {
        return false;
    }
    return true;
};
export default function getBaseUrl() {
    var isOpti = getIsOpti();
    if (!isOpti) {
        return OpenAPI.BASE;
    }
    return "/".concat(document.documentElement.lang);
}
export function getBaseUrlContentApi() {
    var isOpti = getIsOpti();
    if (!isOpti) {
        return OpenAPI.BASE.replace('/en', '');
    }
    return '';
}
